import {
  customProps,
  ITypographyProps,
  spacingProps,
} from 'components/common/commonStyles'
import styled, { css, DefaultTheme } from 'styled-components'

export const commonTypographyStyles = (
  p: ITypographyProps & { theme: DefaultTheme }
) => css`
  text-align: ${p.align ?? 'inherit'};
  margin: 0;
  padding: 0;
  ${p.onClick && 'cursor: pointer'};
  font-weight: ${p.bold ? 500 : 300};
  font-family: ${p.theme.fontFamily.regular};

  ${p.s && `font-size: ${p.s}px;`};
  color: ${() => {
    if (p.primary) return p.theme.colors.primary
    if (p.secondary) return p.theme.colors.textSecondary
    if (p.tertiary) return p.theme.colors.textTertiary
    return p.theme.colors.text
  }};
`

export const H1 = styled.h1<ITypographyProps>(
  () => css`
    font-size: 48px;
    ${commonTypographyStyles};
    ${spacingProps};
    ${customProps};
  `
)

export const WelcomeHeader = styled.h1<ITypographyProps>(
  () => css`
    font-size: 96px;
    ${commonTypographyStyles};
    ${spacingProps};
    ${customProps}
  `
)
export const SubWelcomeHeader = styled.h1<ITypographyProps>(
  () => css`
    font-size: 64px;
    ${commonTypographyStyles};
    ${spacingProps};
    ${customProps}
  `
)

export const Header = styled.h2<ITypographyProps>(
  () => css`
    ${commonTypographyStyles};
    ${spacingProps};
    ${customProps}
  `
)

export const Body = styled.p<ITypographyProps>(
  () => css`
    ${commonTypographyStyles};
    ${spacingProps};
    ${customProps}
  `
)
